export class Error {
  errors: {[key: string]: string} = {};
}
